import { createFileRoute, redirect } from "@tanstack/react-router";

const CURATION_TAB = "curation";

// Split into per-entity pages.
export const Route = createFileRoute("/admin/consignment/onboarding/")({
	validateSearch: (search: Record<string, unknown>): { tab?: string } =>
		typeof search.tab === "string" ? { tab: search.tab } : {},
	beforeLoad({ search }) {
		if (search.tab === CURATION_TAB) {
			throw redirect({ to: "/admin/consignment-curation", replace: true });
		}
		throw redirect({
			to: "/admin/consignment-setting",
			replace: true,
		});
	},
});
